import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';
import InfoWidgetItemWithPaper from '../../../InfoWidgetList/InfoWidgetItemWithPaper';
import CircledIcon from '../../../../library/CircledIcon';
import { PricingIconTypes } from '../../../../../types/enums';
import { SitePricingDiscount } from '../../../../../store/features/discounts/types';
import { useGetAppliedDiscountMessage } from '../../../../../hooks/discount/useGetAppliedDiscountMessage';
import { PricingIcons } from '../../../../../helpers/icons/icons';

interface VIPCodeInfoProps {
  onCloseHandler: () => void;
  codeDiscountResult?: SitePricingDiscount;
  code?: string;
}

export default function VIPCodeInfo(props: VIPCodeInfoProps) {
  const {
    onCloseHandler,
    codeDiscountResult,
    codeDiscountResult: { success } = {},
    code,
  } = props;
  const theme = useTheme();
  const Icon =
    PricingIcons[
      success ? PricingIconTypes.checkIcon : PricingIconTypes.closeIcon
    ];
  const { title, text } = useGetAppliedDiscountMessage({
    discount: codeDiscountResult,
    code,
  });
  const circledIconColor = success
    ? theme.palette.customSuccess.mainRGB
    : theme.palette.customError.darkRGB;
  const iconColor = success
    ? theme.palette.customSuccess.darkCustom
    : theme.palette.customError.mainCustom;

  return (
    <InfoWidgetItemWithPaper
      icon={
        <CircledIcon backgroundRGBColor={circledIconColor} opacity={0.2}>
          <Icon sx={{ color: iconColor }} />
        </CircledIcon>
      }
      closeIcon={
        <CloseIcon
          onClick={onCloseHandler}
          sx={{
            color: theme.palette.brandPrimary.mainCustom,
            cursor: 'pointer',
          }}
        />
      }
      title={title}
      description={text}
    />
  );
}
